import { createAction, props } from '@ngrx/store';
import { IZIndexConfig } from '../z-index-config.interface';

const modulePrefix = '[ZIndexModule]';

export const setConfig = createAction(`${modulePrefix} Set config`, props<{ config: IZIndexConfig }>());

export const setItem = createAction(`${modulePrefix} Set Item`, props<{ id: string }>());
